import { FiX, FiSettings } from "react-icons/fi";
import Area from "components/charts/Area/Area";
import areaApiConfig from "config/charts/areaApiConfig";
import Gauge from "components/charts/Gauge/Gauge";
import { useState, useEffect, useContext } from "react";
import { ModalContext } from "hooks/ModalProvider";
import { Item } from "types/common";
import { getTagData } from "api/tags";
import classNames from "utilities/ClassNames";

const ServerModal = ({ onClose, onEdit, title }: { onClose?: any, onEdit?: any, title?: string }) => {

  const rackSlots = [
    { label: "Server", height: 1 },
    { label: "", height: 1 },
    { label: "", height: 1 },
    { label: "Switcher", height: 1 },
    { label: "", height: 1 },
    { label: "Router", height: 1 },
    { label: "", height: 1 },
    { label: "", height: 1 },
    { label: "", height: 1 },
    { label: "Firewall", height: 2 },
    { label: "Network Balancer", height: 3 },
    { label: "", height: 1 },
    { label: "", height: 1 },
    { label: "Firewall", height: 1 },
    { label: "Server", height: 4 },
    { label: "Server", height: 2 },
  ];

  const tabs = [
    {
      id: 'genInfo',
      label: 'General Informatio',
      content: null
    },
    {
      id: 'status',
      label: 'Status & Metrics',
      content: null
    },
    {
      id: 'connectivity',
      label: 'Connectivity',
      content: null
    },

  ];

  const tableTabs = [
    {
      id: 'graph',
      label: 'Graph',
      content: null
    },
    {
      id: 'alarm',
      label: 'Alarm List',
      content: null
    }
  ];

  const [randomTag, setRandomTag] = useState<Item | null>(null);
  const [selectedTab, setSelectedTab] = useState('genInfo');
  const [selectedTableTab, setSelectedTableTab] = useState('graph');
  const [serverTableData, setServerTableData] = useState<any[]>([]);
  const [graphName, setGraphName] = useState('Power Consumption');
  const [selectedSlot, setSelectedSlot] = useState('Server');
  const { setServersModalShown } = useContext(ModalContext);

  const serverData = [
    { label: "Device name", value: `${selectedSlot}-HP-DL360p` },
    { label: "Type", value: `${selectedSlot}` },
    { label: "Model HP", value: "PrioLiant DL360p Gen8" },
    { label: "Serial Number", value: "SN12345678" },
    { label: "Vendor", value: "Hewlett-Packard" },
    { label: "U-Position", value: "U25-U27" },
    { label: "Device Asset Tag/CMDB ID", value: "DC-BLD-A1-25" },
    { label: "Location", value: "Room1/Rack-34/Raw 5" },
    { label: "Owner", value: "SDAIA" },
  ];

  const getSingleTag = async () => {
    const randomTagData = await getTagData([244]);
    setRandomTag(randomTagData.data[0]);
  };

  useEffect(() => {
    getSingleTag();
  }, []);

  useEffect(() => {
    setServerTableData(serverData);
  }, [graphName, selectedSlot]);

  useEffect(() => {
    if (selectedTab === 'genInfo') {
      setServerTableData(serverData);
    } else {
      setServerTableData([]);
    }
  }, [selectedTab]);

  const [slotHeight, setSlotHeight] = useState(30);

  useEffect(() => {
    const updateHeight = () => {
      setSlotHeight(window.innerWidth < 1750 ? 20 : 30);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <div className="h-screen w-screen bg-black/65 flex items-center justify-center fixed left-0 top-0 z-50"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onMouseMove={(e) => e.stopPropagation()}
      onWheel={(e) => e.stopPropagation()}
      onContextMenu={(e) => e.preventDefault()}
    >
      <div className="h-[85%] w-[1200px] xl-2xl:w-[1100px] 2xl:w-[1300px] bg-black px-3 py-2 flex flex-col gap-2 overflow-hidden">
        <div className="bg-dark/85 relative w-full p-1 px-2 rounded flex h-max">
          <h2 className="2xl:text-2xl w-full text-center">{title ? title : 'Rack-1'}</h2>
          <div className="absolute right-2 h-full top-0 flex items-center justify-center">
            <div className="flex gap-2">
              <button
                className="cursor-pointer bg-blue rounded-md p-0.5 2xl:p-1"
                onClick={() => {
                  setServersModalShown(false);
                  if (onClose) {
                    onClose();
                  }
                }}
              >
                <FiX size={20} />
              </button>
              {onEdit &&
                <button
                  className="cursor-pointer bg-blue rounded-md p-0.5 2xl:p-1"
                  onClick={() => onEdit()}
                >
                  <FiSettings size={20} />
                </button>
              }
            </div>
          </div>
        </div>
        <div className="flex gap-2 w-full flex-1 overflow-hidden">
          <div className="h-full w-1/2 bg-dark flex items-center justify-center rounded-md">
            <div className="relative w-64 perspective-1000 flex h-max">
              <div className="w-full">
                <div className="h-4 w-full">
                  <div className="h-full bg-black transform origin-bottom skew-x-[-50deg]" />
                </div>
                <div className="border border-midnight border-l-blue border-b-blue border-t-blue border-r-blue">
                  {rackSlots.map((slot, i) => (
                    <div
                      key={i}
                      className={`border border-midnight bg-black text-white text-center flex items-center justify-center`}
                      style={{ height: `${slot.height * slotHeight}px` }}
                      onClick={() => setSelectedSlot(slot.label)}
                    >
                      {slot.label}
                    </div>
                  ))}
                </div>
              </div>
              <div className="w-4 pt-4">
                <div className="w-[19px] h-full bg-black transform origin-left skew-y-[-40deg] border border-midnight"></div>
              </div>
            </div>
          </div>
          <div className="h-full w-1/2 bg-dark rounded-md overflow-hidden">
            <div className="flex flex-col gap-2 justify-between h-full py-2 overflow-hidden">
              {randomTag &&
                <div className="px-4 overflow-hidden">
                  <div className="py-1 2xl:py-2 bg-black rounded-lg">
                    <div className="flex max-h-[17vh] 2xl:max-h-[19vh] min-h-0 w-max mx-auto max-w-full">
                      <div className="cursor-pointer"
                        onClick={() => setGraphName('Power Consumption')}
                      >
                        <Gauge
                          data={{ ...randomTag, name: 'Power Consumptions' }}
                          gaugeType={"regular"}
                        />
                      </div>
                      <div className="cursor-pointer"
                        onClick={() => setGraphName('Heat Temperature')}
                      >
                        <Gauge
                          data={{ ...randomTag, name: 'Heat Temperature' }}
                          gaugeType={"regular"}
                        />
                      </div>
                      <div className="cursor-pointer"
                        onClick={() => setGraphName('Humidity')}
                      >
                        <Gauge
                          data={{ ...randomTag, name: 'Humidity' }}
                          gaugeType={"regular"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div>
                <div className="px-4">
                  <div className="py-1 2xl:py-2 bg-black rounded-lg px-4 flex flex-col overflow-hidden">
                    <div className="flex gap-2 mb-2">
                      {tabs.map((tab) =>
                        <div onClick={() => setSelectedTab(tab.id)} key={tab.id} className={`px-2 py-0.5 2xl:py-1  bg-[#373d7e] rounded-md hover:bg-gray-100 cursor-pointer ${selectedTab === tab.id ? 'bg-gradient-to-r from-[#7ED34E] to-[#2E968A] text-white' : ''}`}>
                          <h3 className="text-[12px] font-medium">{tab.label}</h3>
                        </div>
                      )}
                    </div>
                    <table className="w-full min-h-[230px] 2xl:min-h-[250px] overflow-y-scroll">
                      <tbody className="w-full px-4 h-full">
                        {serverTableData && serverTableData.map(({ label, value }, index) => (
                          <tr
                            key={label}
                            className={`px-2 w-full ${index !== serverData.length - 1 ? "border-b border-[#3b5c74]" : ""}`}
                          >
                            <td className="p-0 2xl:p-0.5 px-0 text-xs 2xl:text-[18px]">{label}</td>
                            <td className="p-0 2xl:p-0.5 px-0 text-end text-xs 2xl:text-[18px]">{value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {randomTag &&
                <div className="px-4 flex-1 overflow-hidden">
                  <div className={classNames(selectedTableTab === 'graph' ? "" : "h-full", "py-2 bg-black rounded-lg px-4 overflow-hidden")}>
                    <div className="flex relative gap-2 2xl:mb-2">
                      <div className="h-full w-full absolute top-0 left-0">
                        <div className="flex h-max gap-2">
                          {tableTabs.map((tab) =>
                            <div onClick={() => setSelectedTableTab(tab.id)} key={tab.id} className={`px-2 py-0.5 2xl:py-1 bg-[#373d7e] rounded-md hover:bg-gray-100 cursor-pointer ${selectedTableTab === tab.id ? 'bg-gradient-to-r from-[#7ED34E] to-[#2E968A] text-white' : ''}`}>
                              <h3 className="text-[12px] font-medium">{tab.label}</h3>
                            </div>
                          )}
                        </div>
                      </div>
                      <h3 className="font-bold text-center w-full text-sm 2xl:text-xl">{graphName}</h3>
                    </div>
                    {selectedTableTab === 'graph' && <Area
                      item={randomTag}
                      type="tag"
                      areaType="regular"
                      renderType="lazyLoading"
                      maintainAspectRatio={false}
                      areaApiConfig={areaApiConfig}
                    />}
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default ServerModal;